import loadable from "@loadable/component";
import type { ComponentType } from "react";
import { permissionTypes } from "hooks/usePermissions";
import { DecisionMethodNamesT } from "hooks/usePermissions/types";
import { FeatureFlags } from "types/utils/featureFlags";

type SalesLeadsTabT = {
  key: string;
  label: string;
  permission?: DecisionMethodNamesT[];
  featureFlag?: FeatureFlags;
  LabelAddon?: ComponentType;
};

const outreachPermissions: DecisionMethodNamesT[] = [
  permissionTypes.POWUR_NECESSITIES,
  permissionTypes.ENTERPRISE_SUPPORT,
  permissionTypes.ENTERPRISE_ADMIN,
  permissionTypes.ENTERPRISE_MANAGER,
];

export const salesLeadsTabs: SalesLeadsTabT[] = [
  {
    key: "leads",
    label: "Leads",
  },
  {
    key: "convert",
    label: "Convert",
    permission: outreachPermissions,
  },
  {
    key: "wallet",
    label: "Wallet",
    permission: outreachPermissions,
    featureFlag: FeatureFlags.LEAD_WALLET,
    LabelAddon: loadable(() => import("./WalletTab/WalletBalancePill")),
  },
];
